import React from 'react';
import mederiLogo from './mederi-logo.svg';
import './MederiBrand.css';

export const MederiBrand: React.FC<{ dark?: boolean; compact?: boolean }> = ({ dark = false, compact = false }) => (
  <span className={`mederi-doctor-brand${dark ? ' mederi-doctor-brand--dark' : ''}${compact ? ' mederi-doctor-brand--compact' : ''}`} role="img" aria-label="mederi doctor">
    <img src={compact ? `${process.env.PUBLIC_URL}/favicon.ico` : mederiLogo} alt="" />
    {!compact && <span className="mederi-doctor-brand-label" aria-hidden="true">doctor</span>}
  </span>
);
